<template>
  <section class="member-panel record-center" :class="`record-${mode}`">
    <header v-if="mode !== 'welfare'" class="member-panel-heading"><h1>{{ heading }}</h1><p>{{ mode === 'welfare' ? '查询本人福利记录，金额与状态以实际发放为准' : '当前系统支持查询最近30日的交易记录' }}</p></header>
    <div v-if="mode === 'welfare'" class="welfare-entries"><button @click="navigate('/mine/rebate')"><span class="welfare-symbol"><SiteIcon name="money" :size="22" /></span><b>实时返水</b><span>秒返不停 边玩边赚</span><i>去查看 ›</i></button><button @click="couponOpen = true"><span class="welfare-symbol"><SiteIcon name="ticket" :size="22" /></span><b>口令优惠券</b><span>惊喜加码 专享回馈</span><i>去兑换 ›</i></button></div>
    <PageState v-if="!isLoggedIn" title="登录后查看记录" description="记录只对本人展示"><button class="primary" @click="openAuth('login')">登录</button></PageState>
    <template v-else>
      <ActivityBonusRecords v-if="mode === 'welfare'" />
      <form class="record-filters" @submit.prevent="search">
        <label v-if="mode === 'transactions'">类型<select v-model="filters.type"><option value="deposit">存款</option><option value="transfer">转账</option><option value="withdrawal">取款</option><option value="wallet">钱包账变</option></select></label>
        <template v-if="mode === 'bets'"><label>平台<select v-model="filters.venueId"><option value="">全部</option><option v-for="venue in availableVenues" :key="venue.id" :value="venue.id">{{ venue.name }}</option></select></label><label>状态<select v-model="filters.status"><option value="">全部</option><option value="1">未结算</option><option value="2">已结算</option><option value="3">已取消</option><option value="4">已作废</option></select></label></template>
        <template v-if="mode === 'welfare'"><label>类型<select v-model="filters.recordType"><option value="WELFARE">福利</option><option value="REWARD">奖励</option><option value="COUPON">优惠券</option><option value="GUESS">竞猜</option><option value="RACE">赛事</option><option value="RED_PACKET">红包</option><option value="VIRTUAL_ACTIVITY">虚拟活动</option></select></label><label>状态<select v-model="filters.status"><option value="">全部</option><option value="PENDING">待审核</option><option value="APPROVED">审核通过</option><option value="REJECTED">审核不通过</option></select></label></template>
        <template v-else><div class="date-range-filter"><span>日期</span><!-- 统一选择记录查询日期范围及快捷时间。 --><DateRangePicker v-model:start="filters.start" v-model:end="filters.end" :max="today" :shortcuts="shortcuts" @change="selectedDays = null" @shortcut="setRange" /></div></template>
        <div class="record-filter-actions"><button class="primary" :disabled="loading">{{ loading ? '查询中…' : '查询' }}</button><button class="subtle-button" type="button" @click="reset">重置</button></div>
      </form>
      <p v-if="mode === 'welfare'" class="record-note">福利记录暂按类型与审核状态查询。</p>
      <p v-if="validationError" class="field-error" role="alert">{{ validationError }}</p>
      <div v-if="mode === 'bets' && !loading && !error" class="record-summary">共计 {{ total }} 笔投注 <span v-if="summary.totalValidBetAmount !== undefined">有效投注额：{{ formatDecimal(summary.totalValidBetAmount) }}</span><span v-if="summary.totalWinLossAmount !== undefined">输赢：{{ formatDecimal(summary.totalWinLossAmount) }}</span></div>
      <div class="record-table-scroll" :aria-busy="loading"><table class="record-table"><thead><tr><th v-for="column in columns" :key="column.key">{{ column.label }}</th><th>操作</th></tr></thead><tbody><tr v-for="(row, index) in records" :key="row.id"><td v-for="column in columns" :key="column.key"><FinanceRecordStatus v-if="column.key === 'status' && mode === 'transactions' && filtersApplied.type !== 'wallet'" :type="filtersApplied.type" :record="row" /><span v-else>{{ cell(row, column, index) }}</span></td><td><button class="table-action" :disabled="detailLoading" @click="showDetail(row)">{{ detailLoading === row.id ? '加载中…' : '详情' }}</button></td></tr></tbody></table><PageState v-if="loading || error || !records.length" :loading="loading" :error="error" :title="`暂无${heading}`" description="您可以调整查询条件后重试" @retry="load" /></div>
      <nav v-if="!error && total > 0" class="record-pagination" aria-label="记录分页"><span>共 {{ total }} 条</span><button :disabled="loading || page === 1" @click="changePage(-1)">‹ 上一页</button><span>{{ page }} / {{ pageCount }}</span><button :disabled="loading || page >= pageCount" @click="changePage(1)">下一页 ›</button></nav>
    </template>
    <div v-if="detail" class="modal-backdrop" @click.self="detail = null"><section class="record-detail-dialog record-detail-view" role="dialog" aria-modal="true" aria-labelledby="record-detail-heading" tabindex="-1" @keydown.esc="detail = null"><header class="record-detail-header"><h2 id="record-detail-heading">{{ heading }}详情</h2><button type="button" class="modal-close" aria-label="关闭记录详情" @click="detail = null">×</button></header><dl class="record-detail-fields"><div v-for="item in detailItems" :key="item.key" class="record-detail-field"><dt>{{ item.label }}</dt><dd :class="{ 'record-detail-amount': /(?:Amount|Balance)$/.test(item.key) || item.key === 'amount', 'record-detail-status': item.key === 'status' }">{{ item.value }}</dd></div></dl><OrderBalanceDetails v-if="detail.balanceChanges?.length" :changes="detail.balanceChanges" /><FinanceOrderSnapshot v-if="mode === 'transactions'" :record="detail" :withdrawal="filtersApplied.type === 'withdrawal'" /><button v-if="mode === 'prizes' && detail.canModifyReceipt && !receiptEditing" class="subtle-button" @click="receiptEditing = true">修改收货信息</button><form v-if="receiptEditing" class="receipt-edit-form" @submit.prevent="saveReceipt"><label class="stacked-label">收货人<input v-model.trim="receipt.recipientName" required maxlength="100" /></label><label class="stacked-label">收货电话<input v-model.trim="receipt.recipientPhone" required maxlength="30" /></label><label class="stacked-label">完整地址<textarea v-model.trim="receipt.shippingAddress" required maxlength="500"></textarea></label><p v-if="receiptError" class="field-error" role="alert">{{ receiptError }}</p><div class="detail-actions"><button type="button" class="subtle-button" :disabled="receiptSubmitting" @click="receiptEditing = false">取消修改</button><button class="primary" :disabled="receiptSubmitting">{{ receiptSubmitting ? '保存中…' : '保存收货信息' }}</button></div></form></section></div>
    <div v-if="couponOpen" class="modal-backdrop" @click.self="couponOpen = false"><form class="record-detail-dialog" role="dialog" aria-modal="true" aria-labelledby="coupon-heading" @submit.prevent="redeem"><button class="modal-close" type="button" aria-label="关闭兑换" @click="couponOpen = false">×</button><h2 id="coupon-heading">口令优惠券</h2><label class="stacked-label">优惠口令<input v-model.trim="couponCode" required maxlength="64" placeholder="请输入优惠口令" /></label><p v-if="couponError" class="field-error" role="alert">{{ couponError }}</p><button class="primary" :disabled="couponSubmitting">{{ couponSubmitting ? '兑换中…' : '确认兑换' }}</button></form></div>
  </section>
</template>
<script setup>
import { computed, nextTick, onBeforeUnmount, ref, watch } from 'vue'
import { useAppContext } from '../../composables/appContext'
import { webApi } from '../../services/webApi'
import { buildRecordQuery, dateInputValue, displayRecordTime, recordDateRange, recordTypeFromSearch } from '../../utils/recordQueries.js'
import { formatDecimal } from '../../utils/formatDecimal.js'
import PageState from '../feedback/PageState.vue'
import DateRangePicker from '../DateRangePicker.vue'
import SiteIcon from '../SiteIcon.vue'
import FinanceRecordStatus from '../FinanceRecordStatus.vue'
import { financeRecordStatus } from '../../utils/financeRecordStatus.js'
import OrderBalanceDetails from '../OrderBalanceDetails.vue'
import FinanceOrderSnapshot from '../FinanceOrderSnapshot.vue'
import ActivityBonusRecords from '../activities/ActivityBonusRecords.vue'
const { currentPath, currentSearch = ref(''), isLoggedIn, availableVenues, navigate, notify, openAuth } = useAppContext()
const mode = computed(() => currentPath.value.endsWith('betRecord') ? 'bets' : currentPath.value.endsWith('giftRecord') ? 'prizes' : currentPath.value.endsWith('welfare') ? 'welfare' : 'transactions')
const heading = computed(() => ({ bets: '投注记录', prizes: '兑奖记录', welfare: '福利记录', transactions: '交易记录' }[mode.value]))
const defaults = () => ({ type: recordTypeFromSearch(currentSearch.value), venueId: '', status: mode.value === 'bets' ? '2' : '', recordType: 'WELFARE', ...recordDateRange(1) })
const filters = ref(defaults())
const filtersApplied = ref(defaults())
const today = dateInputValue()
const shortcuts = [{ label: '今日', days: 1 }, { label: '昨日', days: -1 }, { label: '近7日', days: 7 }, { label: '近30日', days: 30 }]
const selectedDays = ref(1)
const records = ref([]), total = ref(0), page = ref(1), loading = ref(false), error = ref(''), validationError = ref(''), summary = ref({}), detail = ref(null), detailLoading = ref(null)
const couponOpen = ref(false), couponCode = ref(''), couponError = ref(''), couponSubmitting = ref(false)
const receiptEditing = ref(false), receiptSubmitting = ref(false), receiptError = ref(''), receipt = ref({ recipientName: '', recipientPhone: '', shippingAddress: '' })
let version = 0, detailVersion = 0
const pageCount = computed(() => Math.max(1, Math.ceil(total.value / 10)))
const columns = computed(() => {
  const time = { key: 'time', label: mode.value === 'prizes' ? '申请时间' : '日期' }
  if (mode.value === 'bets') return [time, { key: 'orderNo', label: '订单号' }, { key: 'venueName', label: '平台' }, { key: 'gameName', label: '投注内容' }, { key: 'status', label: '注单状态' }, { key: 'betAmount', label: '投注金额' }, { key: 'winLossAmount', label: '输赢金额' }, { key: 'validBetAmount', label: '有效投注额' }]
  if (mode.value === 'prizes') return [{ key: 'index', label: '序号' }, time, { key: 'orderNo', label: '订单号' }, { key: 'activityTitle', label: '活动名称' }, { key: 'prizeName', label: '奖品名称' }, { key: 'prizeType', label: '奖品类型' }, { key: 'status', label: '状态' }]
  if (mode.value === 'transactions' && filtersApplied.value.type === 'wallet') return [{ key: 'index', label: '序号' }, time, { key: 'orderNo', label: '流水号' }, { key: 'type', label: '流水类型' }, { key: 'direction', label: '收支方向' }, { key: 'amount', label: '变动金额' }, { key: 'afterBalance', label: '变动后余额' }]
  if (mode.value === 'welfare') return [{ key: 'index', label: '序号' }, time, { key: 'recordNo', label: '订单号' }, { key: 'title', label: '红利信息' }, { key: 'amount', label: '金额' }, { key: 'status', label: '状态' }]
  return [{ key: 'index', label: '序号' }, time, { key: 'orderNo', label: '订单号' }, { key: 'type', label: '交易类型' }, { key: 'amount', label: '金额' }, { key: 'status', label: '状态' }]
})
function cell(row, column, index) {
  if (column.key === 'index') return (page.value - 1) * 10 + index + 1
  if (column.key === 'time') return displayRecordTime(row.betAt || row.appliedAt || row.createdAt || row.orderedAt)
  if (column.key === 'orderNo') return row.orderNo || row.transactionNo || '--'
  if (column.key === 'direction') return { IN: '收入', OUT: '支出' }[row.direction] || row.direction || '--'
  if (column.key === 'type') return row.transactionTypeName || { DEPOSIT: '存款', WITHDRAWAL: '取款', TRANSFER: '转账', BONUS: '红利', MEMBER_REBATE: '会员返水' }[row.transactionType] || row.transactionType || { deposit: '存款', transfer: '转账', withdrawal: '取款', wallet: '账变' }[filtersApplied.value.type]
  if (column.key === 'prizeType') return { PHYSICAL: '实物', VIRTUAL: '虚拟', BONUS: '红利' }[row.prizeType] || row.prizeType || '--'
  if (column.key === 'status' && mode.value === 'transactions' && filtersApplied.value.type !== 'wallet') return financeRecordStatus(filtersApplied.value.type, row).label
  if (column.key === 'status' && mode.value === 'welfare') return { PENDING: '待审核', APPROVED: '审核通过', REJECTED: '审核不通过', PENDING_CLAIM: '待领取', CLAIMED: '已领取', EXPIRED: '已过期' }[row.status] || row.statusName || row.status || '--'
  if (column.key === 'status') return row.statusName || (mode.value === 'bets' ? { 1: '未结算', 2: '已结算', 3: '已取消', 4: '已作废' }[row.status] : row.status) || '--'
  return row[column.key] ?? '--'
}
async function load() {
  const ticket = ++version
  if (!isLoggedIn.value) { loading.value = false; records.value = []; total.value = 0; return }
  loading.value = true; error.value = ''; records.value = []; total.value = 0; summary.value = {}
  const applied = filtersApplied.value
  try {
    const query = mode.value === 'welfare' ? { pageNumber: page.value, pageSize: 10 } : buildRecordQuery(applied, page.value)
    let response
    if (mode.value === 'bets') response = await webApi.betOrders({ ...query, ...(applied.venueId ? { venueId: Number(applied.venueId) } : {}), ...(applied.status ? { status: Number(applied.status) } : {}) })
    else if (mode.value === 'prizes') response = await webApi.prizeOrders(query)
    else if (mode.value === 'welfare') response = await webApi.unifiedRecords({ ...query, recordType: applied.recordType, ...(applied.status ? { status: applied.status } : {}) })
    else response = await ({ deposit: webApi.depositOrders, withdrawal: webApi.withdrawalOrders, transfer: webApi.transferOrders, wallet: webApi.walletTransactions }[applied.type])(query)
    if (ticket !== version) return
    records.value = response?.data || []; total.value = Number(response?.total) || 0; summary.value = response || {}
  } catch (e) { if (ticket === version) error.value = e.message || '记录加载失败' }
  finally { if (ticket === version) loading.value = false }
}
function search() {
  try { if (mode.value !== 'welfare') buildRecordQuery(filters.value); validationError.value = ''; filtersApplied.value = { ...filters.value }; page.value = 1; detail.value = null; detailVersion++; void load() }
  catch (e) { validationError.value = e.message }
}
function reset() { filters.value = defaults(); selectedDays.value = 1; search() }
function setRange(days) { Object.assign(filters.value, recordDateRange(days)); selectedDays.value = days }
function changePage(step) { page.value = Math.max(1, Math.min(pageCount.value, page.value + step)); void load() }
async function showDetail(row) {
  const ticket = ++detailVersion
  detailLoading.value = row.id
  try {
    let result = row
    if (mode.value === 'bets') result = await webApi.betOrderDetail(row.id)
    else if (mode.value === 'prizes') result = await webApi.prizeOrder(row.id)
    else if (mode.value === 'transactions') result = await ({ deposit: webApi.depositOrderDetail, withdrawal: webApi.withdrawalOrderDetail, transfer: webApi.transferOrderDetail, wallet: webApi.walletTransactionDetail }[filtersApplied.value.type])(row.id)
    if (ticket !== detailVersion) return
    detail.value = result; receiptEditing.value = false; receiptError.value = ''; receipt.value = { recipientName: result.recipientName || '', recipientPhone: result.recipientPhone || '', shippingAddress: result.shippingAddress || '' }
    await nextTick(); document.querySelector('.record-detail-dialog')?.focus()
  } catch (e) { if (ticket === detailVersion) notify(e.message || '详情加载失败') }
  finally { if (ticket === detailVersion) detailLoading.value = null }
}
const detailItems = computed(() => {
  if (!detail.value) return []
  const row = detail.value
  const items = columns.value.filter(column => column.key !== 'index').map(column => ({ key: column.key, label: column.label, value: cell(row, column, 0) }))
  const extras = [['currency', '币种'], ['fromWalletName', '转出钱包'], ['toWalletName', '转入钱包'], ['recipientName', '收货人'], ['recipientPhone', '收货电话'], ['shippingAddress', '收货地址'], ['trackingCompany', '物流公司'], ['trackingNo', '物流单号'], ['fulfillmentInfo', '兑换说明'], ['failedReason', '失败原因'], ['failureReason', '失败原因'], ['beforeBalance', '变动前余额'], ['relatedOrderNo', '关联订单号'], ['remark', '备注'], ['betDetail', '投注详情']]
  return [...items, ...extras.filter(([key]) => row[key]).map(([key, label]) => ({ key, label, value: row[key] }))]
})
async function saveReceipt() {
  if (receiptSubmitting.value || !isLoggedIn.value || !detail.value?.canModifyReceipt) return
  if (Object.values(receipt.value).some(value => !value.trim())) { receiptError.value = '请完整填写收货信息'; return }
  const ticket = detailVersion, id = detail.value.id
  receiptSubmitting.value = true; receiptError.value = ''
  try {
    await webApi.updatePrizeReceipt(id, { ...receipt.value })
    if (ticket !== detailVersion || !isLoggedIn.value || detail.value?.id !== id) return
    notify('收货信息已保存'); await showDetail({ id })
  } catch (e) { if (ticket === detailVersion) receiptError.value = e.message || '保存失败，已保留填写内容' }
  finally { receiptSubmitting.value = false }
}
async function redeem() {
  if (!isLoggedIn.value) { openAuth('login'); return }
  if (couponSubmitting.value) return
  couponSubmitting.value = true; couponError.value = ''
  const ticket = version
  try { const result = await webApi.redeemCoupon({ couponPassword: couponCode.value }); if (ticket !== version || !isLoggedIn.value) return; notify(result?.message || '优惠券兑换成功'); couponOpen.value = false; couponCode.value = ''; await load() }
  catch (e) { if (ticket === version) couponError.value = e.message || '兑换失败' }
  finally { couponSubmitting.value = false }
}
watch([mode, isLoggedIn, currentSearch], () => { version++; detailVersion++; detail.value = null; detailLoading.value = null; couponOpen.value = false; filters.value = defaults(); filtersApplied.value = defaults(); page.value = 1; void load() }, { immediate: true })
onBeforeUnmount(() => { version++; detailVersion++ })
</script>

<style scoped>
/* 桌面筛选优先同行，空间不足时按完整控件自然换行。 */
@media (min-width: 768px) {
  .record-center .record-filters {
    gap: 14px 12px;
  }
  .record-center .record-filters > label,
  .record-center.record-transactions .record-filters > label:first-child {
    flex: 0 1 auto;
    white-space: nowrap;
  }
  .record-center .record-filters > label select,
  .record-center.record-transactions .record-filters > label:first-child select {
    width: 128px;
    min-width: 0;
  }
  .record-center .date-range-filter {
    flex: 0 1 328px;
    min-width: 300px;
  }
  .record-center .date-range-filter :deep(.date-range-picker) {
    flex: 1;
    width: auto;
    min-width: 0;
  }
  .record-center .record-filters .record-filter-actions {
    flex: 0 0 auto;
    width: auto;
    margin-left: auto;
    gap: 8px;
  }
  .record-center .record-filter-actions button {
    width: 76px;
    padding-inline: 12px;
  }
}
.record-detail-view {
  width: min(560px, 100%);
  max-height: calc(100dvh - 40px);
  padding: 24px;
  border-radius: 18px;
}
.record-detail-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 18px;
  padding-bottom: 18px;
  border-bottom: 1px solid #e8eef6;
}
.record-detail-header h2 {
  margin: 0;
  color: #22344e;
  font-size: 20px;
  line-height: 1.4;
}
.record-detail-header .modal-close {
  position: static;
  flex: none;
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border-radius: 50%;
  background: #f2f6fb;
  font-size: 24px;
  line-height: 1;
}
.record-detail-header .modal-close:hover {
  color: #238fd6;
  background: #e6f3ff;
}
.record-detail-view .record-detail-fields {
  display: block;
  margin: 0;
  overflow: hidden;
  border: 1px solid #e7edf5;
  border-radius: 12px;
}
.record-detail-field {
  display: grid;
  grid-template-columns: 104px minmax(0, 1fr);
  align-items: start;
  gap: 16px;
  padding: 11px 16px;
  line-height: 1.6;
}
.record-detail-field + .record-detail-field {
  border-top: 1px solid #edf1f7;
}
.record-detail-field:nth-child(odd) {
  background: #f8faff;
}
.record-detail-field dt {
  color: #7c8a9f;
}
.record-detail-field dd {
  min-width: 0;
  margin: 0;
  color: #354b67;
  overflow-wrap: anywhere;
}
.record-detail-field .record-detail-amount {
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}
.record-detail-field .record-detail-status {
  justify-self: start;
  padding: 1px 8px;
  border-radius: 5px;
  color: #287eae;
  background: #e7f3fc;
}
@media (max-width: 600px) {
  .record-detail-view {
    max-height: calc(100dvh - 24px);
    padding: 20px;
    border-radius: 16px;
  }
  .record-detail-header h2 {
    font-size: 18px;
  }
  .record-detail-field {
    grid-template-columns: 84px minmax(0, 1fr);
    gap: 12px;
    padding: 10px 12px;
  }
}
</style>
